var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 46C18.451 46 14.0042 44.6511 10.2219 42.1238C6.43956 39.5965 3.4916 36.0044 1.75078 31.8017C0.00996551 27.599 -0.445511 22.9745 0.441949 18.5129C1.32941 14.0514 3.51994 9.95316 6.73655 6.73655C9.95316 3.51994 14.0514 1.32941 18.5129 0.441949C22.9745 -0.445511 27.599 0.00996551 31.8017 1.75078C36.0044 3.4916 39.5965 6.43956 42.1238 10.2219C44.6511 14.0042 46 18.451 46 23C46 29.1 43.5768 34.9501 39.2634 39.2634C34.9501 43.5768 29.1 46 23 46ZM23 3.28572C19.1009 3.28572 15.2893 4.44195 12.0473 6.60818C8.80534 8.77441 6.27851 11.8534 4.78638 15.4557C3.29426 19.058 2.90385 23.0219 3.66453 26.8461C4.42521 30.6703 6.30281 34.183 9.0599 36.9401C11.817 39.6972 15.3297 41.5748 19.1539 42.3355C22.9781 43.0962 26.942 42.7057 30.5443 41.2136C34.1466 39.7215 37.2256 37.1947 39.3918 33.9527C41.5581 30.7107 42.7143 26.8991 42.7143 23C42.7143 17.7715 40.6372 12.757 36.9401 9.0599C33.243 5.36276 28.2286 3.28572 23 3.28572Z",
    fill: "#F3742F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.541 32.8571L21.3574 23.6736V8.21429H24.6431V22.31L32.8574 30.5407L30.541 32.8571Z",
    fill: "#F3742F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIconOrange);
export default __webpack_public_path__ + "static/media/clock-icon-orange.57afd03b.svg";
export { ForwardRef as ReactComponent };